import { useState, useEffect } from 'react';
import type { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

export function useObservable<T>(observable: Observable<T>, initialValue: T): T {
  const [value, setValue] = useState<T>(() =>
    observable instanceof BehaviorSubject ? observable.value : initialValue
  );
  useEffect(() => {
    const sub = observable.subscribe(setValue);
    return () => sub.unsubscribe();
  }, [observable]);
  return value;
}
